    import { encode, decode } from "./base64";
    // 调原生的方法
    export function connectWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
      } else {
        document.addEventListener(
          "WebViewJavascriptBridgeReady",
          function () {
            return callback(window.WebViewJavascriptBridge);
          },
          false
        );
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback];
      var WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      WVJBIframe.src = "gomescheme://__BRIDGE_LOADED__";
      // WVJBIframe.src = 'gomefinancescheme://__BRIDGE_LOADED__';
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
      // callback();
    }

    // 内核判断
    const deviceCore = {
      _ua: navigator.userAgent.toLowerCase(),
      // 获取浏览器版本
      _getVersion: (nece) => {
        if (typeof nece !== "string") {
          return "";
        }
        const arr = nece.split(".");
        return parseFloat(`${arr[0]}.${arr[1]}`);
      },
      // 设备检测
      _detect: (kernel) => {
        const reg = new RegExp(kernel, "i", "g");
        return reg.test(deviceCore._ua);
      },
    };
    export const device = {
      isIOS: deviceCore._detect("iPhone|iPad|iPod|iOS|mac os"),
      isAndroid: deviceCore._detect("Android"),
      isUCBrowser: deviceCore._detect("UCBrowser"),
      isQQBrowser: deviceCore._detect("QQBrowser"),
      isWeixin: deviceCore._detect("MicroMessenger"),
      isPC: !deviceCore._detect(
        "phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone"
      ),
      qqBrowserVersion: deviceCore._detect("QQBrowser")
        ? deviceCore._getVersion(deviceCore._ua.split("mqqbrowser/")[1])
        : 0,
      ucBrowserVersion: deviceCore._detect("UCBrowser")
        ? deviceCore._getVersion(deviceCore._ua.split("ucbrowser/")[1])
        : 0,
      isIPhoneX:
        deviceCore._detect("iPhone|iPad|iPod|iOS|mac os") &&
        window.screen.height === 812 &&
        window.screen.width === 375,
      // 是否国美易卡 App 内
      isGomeCard: deviceCore._detect("gomecard"),
      // 是否在Plus内
      isGomePlus: deviceCore._detect("gomeplus"),
      isGomeFinance: deviceCore._detect("gomeFinance"),
    };
    /**
     * 点击,跳转页面并增加埋点
     * @param {*跳转的h5或原生页面} url
     * @param {*埋点的数据} trackId
     */
    export const goIndex = (url, trackId, skip, item = {}, isDontNeedParmas) => {
      console.log("device.isGomeFinance----------", device.isGomeFinance);
      console.log("device--------", device);
      console.log('item=-=============', JSON.stringify(item));
      const params = getParams();
      //  let source = window.sessionStorage.getItem('source') || params.source;

      // 获取除页面本身的pageId，isPreview外的所有参数并透传
      const { isPreview, pageId, ...otherParams } = params;
      const reg = /source=/gi;

      // if (url && source === 'app') {
      //   connectWebViewJavascriptBridge(JSBridge => {
      //     JSBridge.callHandler('gome_secondpage', url);
      //   });
      // } else
      if (url && url !== "null") {
        if (device.isGomePlus) {
          // 借钱页底部点击去财富
          if (isDontNeedParmas) {
            window.GomeJSBridge.pushWindow(null, null, url);
            return;
          }
          // 避免重复添加source=plus
          if (reg.test(url)) {
            window.GomeJSBridge.pushWindow(
              null,
              null,
              urlObjectToStrings(decodeURI(url), {
                businessLines: item.businessLines,
              })
            );
            return;
          } else {
            window.GomeJSBridge.pushWindow(
              null,
              null,
              urlObjectToStrings(decodeURI(url), {
                businessLines: item.businessLines,
                source: "plus",
              })
            );
            return;
          }
        }
        if (device.isGomeFinance) {
          connectWebViewJavascriptBridge((JSBridge) => {
            JSBridge.callHandler(
              "gome_secondpage",
              urlObjectToStrings(url, {
                businessLines: item.businessLines,
                ...otherParams,
              })
            );
          });
          return;
        }
        // 国美家及金融app需要拼接参数otherParams
        window.location.href = urlObjectToStrings(url, {
          businessLines: item.businessLines,
          ...otherParams,
        });
        return;
      }
      
      if (skip && skip !== "skip_null") {
        // MOD_FUND_XQ 基金详情
        // MOD_MTY 基金美天盈
        if (skip === "MOD_FUND_XQ" || skip === "MOD_MTY") {
          if (!item) return;
          const code = skip === "MOD_MTY" ? "1002" : "1004";
          connectWebViewJavascriptBridge((JSBridge) => {
            JSBridge.callHandler("gome_fund", {
              fundCode: item.productCode,
              code,
            });
          });
          return;
        }
        if (skip === "skip_ykAPP") {
          connectWebViewJavascriptBridge((JSBridge) => {
            JSBridge.callHandler("gome_pushEsayCardApp", {});
          });
          return;
        }

        connectWebViewJavascriptBridge((JSBridge) => {
          JSBridge.callHandler("gome_function", {
            skip,
          });
        });
      }
    };

    // url的参数转化为对象
    export const getParams = (search = window.location.search) => {
      const params = {};
      search
        .slice(1)
        .split("&")
        .forEach((o) => {
          params[o.split("=")[0]] = o.split("=")[1];
        });
      return params;
    };

    /**
     * URL 参数对象转为字符串
     * @param {String} url
     * @param {Object} opts
     */
    export const urlObjectToStrings = (url, opts) => {
      if (typeof opts !== "object") {
        return url;
      }
      const arr = Object.keys(opts);
      const newArr = [];
      arr.forEach((item, index) => {
        if (opts[item]) {
          newArr.push(`${item}=${opts[item]}`);
        }
      });
      const newOpts = newArr.join("&");
      if (newOpts) {
        url = url.indexOf("?") === -1 ? url + "?" : url + "&";
      }
      return url + newOpts;
    };

    // 调原生的方法,获取token
    export const getToken = () => {
      return new Promise((resolve, reject) => {
        connectWebViewJavascriptBridge((JSBridge) => {
          JSBridge.callHandler("gome_token", null, (token) => {
            window.sessionStorage.setItem("source", "app");
            resolve(token);
          });
        });
      });
    };

    // 存储token
    export const setToken = async () => {
      const params = getParams();
      // getToken是异步的,在原生页面调用方法获取token,在网页中获取url参数
      const token = params.accessToken || (await getToken());
      console.log(token, "token");
      const source = params.source;
      // 存储source
      if (source === "app") {
        window.sessionStorage.setItem("source", "app");
      }

      const env = process.env.NODE_ENV;
      // token不为空存储token
      if (token && token !== "null") {
        // if (env === "development") {
        document.cookie = `sessionId=${token}; path=/`;
        // } else {
        //     document.cookie = `sessionId=${token}; path=/; domain=gomefinance.com.cn`;

        // }
      }
      console.log("cookie:" + document.cookie);
    };

    // 在app中调原生的方法,跳登录页面
    // 在浏览器跳登陆页面
    export const setLogin = () => {
      const { source } = getParams();
      if (source === "app") {
        connectWebViewJavascriptBridge((JSBridge) => {
          JSBridge.callHandler("gome_login", null, (url) => {
            window.location.replace(url);
          });
        });
      } else if (source === "plus") {
        window.GomeJSBridge.login(null, null, { refresh: false });
      } else {
        window.location.href = `${process.env.REACT_APP_API_URL
          }gome-sso/login?returnUrl=${encodeURIComponent(window.location.href)}`;
      }
    };

    /**
     * 获取cookie
     * @param key
     * @returns {*}
     */
    export const getCookie = (name) => {
      const aCookie = document.cookie.split("; ");
      if (!aCookie) {
        return;
      }
      let i = 0;
      for (i = 0; i < aCookie.length; i++) {
        const aCookie2 = aCookie[i].split("=");
        if (aCookie2[0] === name) {
          return aCookie2[1];
        }
      }
      return null;
    };
    const getBigData = (item) => {
      return JSON.parse(decode(item));
    };
    const setBigData = (item) => {
      return encode(JSON.stringify(item));
    };
    /**
     * 通过cookie获取userid
     * @param key
     * @returns {userId}
     */
    export const tools = {
      getCookie: getCookie,
      getTdkv: function () {
        return getCookie("DNY_USER_ID");
      },
      getBigData,
      setBigData,
    };

    /**
     * 设置cookie
     * @param key
     * @returns {*}
     */
    export const setCookie = (name, value, expiredays) => {
      const exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        name +
        "=" +
        value +
        (expiredays === null ? "" : ";expires=" + exdate.toGMTString()) +
        ";path=/;";
    };

    /**
     * 转化shareCode 与 shareType
     */
    export const shareTypeToCode = (type) => {
      if (type === 1) {
        return "friend";
      } else if (type === 2) {
        return "weixin";
      } else if (type === 3) {
        return "qq";
      } else if (type === 6) {
        return "weibo";
      }
    };

    /**
     * 人名加*
     */
    export const handleName = (name) => {
      if (!name) {
        return "";
      }
      return name
        .split("")
        .map((item, index) => {
          if (index !== 0) {
            item = "*";
          }
          return item;
        })
        .join("");
    };

    /**
     * 获取APP版本并存储
     */
    export const checkVersion = () => {
      return new Promise((resolve) => {
        connectWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler("gome_parmaslist", function (response) {
            resolve(response);
          });
        });
      });
    };

    /**
     * 获得区域地址
     */
    export const getLocation = () => {
      return new Promise((resolve) => {
        connectWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler("gome_parmaslist", function (response) {
            resolve(response);
          });
        });
      });
    };

    /**
     * 检测是否为期望app版本
     * @param {String} version
     */
    export const compareAppVersion = async (version) => {
      const currentV = await checkVersion();
      console.log(currentV);
      if (!currentV) {
        return "m";
      }
      if (handleVersion(currentV) >= handleVersion(version)) {
        return true;
      } else {
        return false;
      }
    };

    const handleVersion = (version) => {
      const newVersion = version
        .split(".")
        .map((item, index) => {
          if (index !== 0 && item < 10) {
            item = "0" + item;
          }
          if (item >= 100) {
            item = item.substring(0, 2);
          }
          return item;
        })
        .join("");
      return Number(newVersion);
    };

    /**
     * APP分享
     * @param {Object} params
     */
    export const appShare = (params) => {
      connectWebViewJavascriptBridge((JSBridge) => {
        JSBridge.callHandler("gome_share", params);
      });
    };

    /**
     * 截流函数
     * @param {Function} func
     * @param {Number} wait
     */
    export function throttle() {
      let disabled = true;
      return (func, wait = 0) => {
        if (!disabled) {
          return;
        }
        func();
        disabled = false;
        setTimeout(() => {
          disabled = true;
        }, wait);
      };
    }

    /**
     * 防抖函数
     * @param {Function} func
     * @param {Number} wait
     */
    function debounce() {
      let timer = null;
      return (func, wait = 0) => {
        clearTimeout(timer);
        timer = setTimeout(func, wait);
      };
    }
    export const _debounce = debounce();
    /**
     * 判断字符串是否为空
     * @param {*} property
     */
    export function isEmpty(property) {
      return (
        property === null || property === "" || typeof property === "undefined"
      );
    }

    /**
     * 相关正则
     * @param {*} property
     */
    export const validation = {
      mobile: /^1\d{10}$/,
      idNumber: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      name: /[^\u4E00-\u9FA5|·.]/g,
    };

    export function getQueryVariable() {
      const query = window.location.search.substring(1);
      if (isEmpty(query)) return {};
      const vars = query.split("&");
      const obj = {};
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        obj[pair[0]] = pair[1];
      }
      return obj;
    }
